module.exports = __webpack_public_path__ + "img/caracteristicas-rad-conv-moviles.23b77266.png";